var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import styled from '@emotion/styled/macro';
import { CardContainer, CardTitle } from '../../common/cards';
import { useLoadImage } from '../../common/hooks';
import { LoadingPlaceholder } from './CameraCardPlaceholderLoading';
import { OfflinePlaceholder } from './CameraCardPlaceholderOffline';
var CameraCardContainer = styled(CardContainer)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  width: ", ";\n  height: ", ";\n  background: black;\n"], ["\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  width: ", ";\n  height: ", ";\n  background: black;\n"])), function (props) { return props.theme.cameraCard.width; }, function (props) { return props.theme.cameraCard.height; });
var CameraCardContent = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  flex-grow: 1;\n"], ["\n  flex-grow: 1;\n"])));
var CameraImage = styled.img(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  width: 100%;\n"], ["\n  width: 100%;\n"])));
export var CameraCard = function (props) {
    var _a = useLoadImage(props.previewImageSrc), isLoading = _a.isLoading, isLoaded = _a.isLoaded;
    return (React.createElement(CameraCardContainer, null,
        React.createElement(CardTitle, null, props.name),
        React.createElement(CameraCardContent, null, isLoading ?
            React.createElement(LoadingPlaceholder, null) :
            (isLoaded ?
                React.createElement(CameraImage, { src: props.previewImageSrc }) :
                React.createElement(OfflinePlaceholder, null)))));
};
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=CameraCard.js.map